/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M14.1393 11.3605 18 7.5h2.2492c.0125 0 .0257 0 .0382-.0002 1.8885-.0184 3.443-1.4329 3.681-3.261l.0236-.2422L24 3.75C24 1.7618 22.4527.135 20.4966.008L20.25 0h-3c-.0134 0-.0276 0-.041.0002a3.7969 3.7969 0 0 0-.3053.0156 3.7274 3.7274 0 0 0-1.0866.2677c-1.2881.533-2.2146 1.7631-2.3091 3.22L13.5 3.75v7.3447a.375.375 0 0 0 .5602.3262l.0791-.0604ZM12 9.75c0 2.0711-1.6789 3.75-3.75 3.75-2.071 0-3.75-1.6789-3.75-3.75C4.5 7.679 6.179 6 8.25 6 10.3211 6 12 7.679 12 9.75ZM17.3787 6 15 8.3782 14.9992 3.75a2.3118 2.3118 0 0 1 .0076-.1862c.0888-1.084.9459-1.9503 2.0257-2.0535l.2167-.0103 3.1684.0062m0 0c1.0923.0808 1.9676.9414 2.0713 2.0271l.0099.209-.0044.155v.002a2.2412 2.2412 0 0 1-.0142.1455c-.1353 1.039-.9796 1.8501-2.0237 1.9457L20.2492 6h-2.8705m3.0389-4.4938c-.0553-.004.0564 0 0 0ZM16.4571 22.5a8.3747 8.3747 0 0 0-.0203-.1821C15.9339 18.2103 12.4881 15 8.25 15c-4.2376.0006-7.6839 3.2106-8.1868 7.3179A8.5621 8.5621 0 0 0 0 23.3571V24h16.5v-.6429a8.55 8.55 0 0 0-.0429-.8571ZM14.5918 21c.1716.4774.2925.9796.3562 1.5H1.552a6.9156 6.9156 0 0 1 .3562-1.5c.944-2.6267 3.4222-4.5 6.3418-4.5h.021c2.6897.0083 5.0013 1.6057 6.08 3.9159.0888.19.1692.3849.2408.5841ZM8.25 7.5C7.0074 7.5 6 8.5074 6 9.75S7.0074 12 8.25 12s2.25-1.0074 2.25-2.25S9.4926 7.5 8.25 7.5Z"
    clipRule="evenodd"
  />,
  'Support'
);
